export const WELCOME_VIDEO = 'https://fast.wistia.net/embed/iframe/jpv2wlsm8d?videoFoam=true';
export const BACKUP_VIDEO = 'https://fast.wistia.net/embed/iframe/6bmyiytz7x?videoFoam=true';
